module.exports = __webpack_public_path__ + "static/media/career_fair_bg.2ceb3dc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/career_fair_bg.jpg
// module id = 2339
// module chunks = 0